export const featuredPortfolio = [
  {
    id: 1,
    title: "Buddy Allocator",
    img: "assets/Buddy_alloc.jpg",
    weblink: "https://github.com/ValRobichaux/CSCE-313/tree/master/PA1",
    key: "buddyAlloc",
  },
  {
    id: 2,
    title: "Client Server Access",
    img: "assets/clientservermodel.jpg",
    weblink: "https://github.com/ValRobichaux/CSCE-313/tree/master/PA2",
    key: "clientServer",
  },
  {
    id: 3,
    title: "Custom Linux shell",
    img: "assets/linux shell.jpg",
    weblink: "https://github.com/ValRobichaux/CSCE-313/tree/master/PA3",
    key: "linuxShell",
  },
  {
    id: 4,
    title: "TCP and IP communication",
    img: "assets/TCP and IP.jpg",
    weblink: "https://github.com/ValRobichaux/CSCE-313/tree/master/PA5",
    key: "communications",
  },
];

export const schoolPortfolio = [
  {
    id: 1,
    title: "Environment Variables",
    img: "assets/env variable.jpg",
    weblink:
      "https://github.com/ValRobichaux/CSCE-465/tree/main/Environment%20Variables%20and%20Set%20UID",
    key: "envVars",
  },
  {
    id: 2,
    title: "Firewall Experimentation",
    img: "assets/firewall.jpg",
    weblink:
      "https://github.com/ValRobichaux/CSCE-465/tree/main/Firewall%20Experimentation",
    key: "firewall",
  },
  {
    id: 3,
    title: "Packet sniff/spoof",
    img: "assets/packet sniffing and spoofing.png",
    weblink:
      "https://github.com/ValRobichaux/CSCE-465/tree/main/Packet%20Sniffing%20and%20Spoofing",
    key: "packetsLab",
  },
  {
    id: 4,
    title: "SQL injection attack",
    img: "assets/sql injection.jpg",
    weblink:
      "https://github.com/ValRobichaux/CSCE-465/tree/main/SQL%20injection%20attack",
    key: "SQL",
  },
];

export const personalPortfolio = [
  {
    id: 1,
    title: "This very website!",
    img: "assets/portpic.jpg",
    weblink: "https://valrobichaux.com",
    key: "portfolio",
  },
  {
    id: 2,
    title: "My Dev Blog",
    img: "assets/dev blog.jpg",
    weblink: "https://github.com/ValRobichaux/devBlog",
    key: "devBlog",
  },
  {
    id: 3,
    title: "LeetCode Solutions",
    img: "assets/leetcode.jpg",
    weblink: "https://github.com/ValRobichaux/LEETcode-Solutions",
    key: "leetCode",
  },
  {
    id: 4,
    title: "SpaghettiGame",
    img: "assets/unity.png",
    weblink: "https://github.com/ValRobichaux/SpaghettiGame",
    key: "unity",
  },
];

